module.exports = __webpack_public_path__ + "media/48/e-remove-08180765.svg";